import axios from "axios";
import { GeneratedSkedApiClient } from "./generated-client";
import type { paths } from "./generated/sked-api-openapi-types";

type GetAccountStatisticsOperation = paths["/account-statistics/read"]["post"];
type GetAccountStatisticsBody = NonNullable<
  GetAccountStatisticsOperation["requestBody"]
>["content"]["application/json"];
type GetAccountStatisticsResponse =
  GetAccountStatisticsOperation["responses"][200]["content"]["application/json"];

export async function getAccountsStatistic(accountIds: string[]) {
  const generatedSkedApiClient = new GeneratedSkedApiClient<paths>();
  const result = await generatedSkedApiClient.client.POST(
    "/account-statistics/read",
    {
      body: { accountIds } satisfies GetAccountStatisticsBody,
    }
  );

  return (await generatedSkedApiClient.unwrap(
    result
  )) as GetAccountStatisticsResponse;
}

export async function getArchivedPostsCount(accountIds: string[]) {
  const response = await axios.post("/schedules/inactive", {
    "accountIds[]": accountIds,
    page: 1,
  });
  const nonImportedArchivedPosts = (response.data.schedules || []).filter(
    ({ isImported }: { isImported: boolean }) => !isImported
  );
  return nonImportedArchivedPosts.length;
}
